import { Model, RailsFormat } from "./model";

export class TransactionCycleMetadata extends Model {
  constructor(
    public cycleTransactionType: string = null,
    public originalAmountToRecover: number = null,
    public amountProcessedSince: number = null,
    public rootTransactionDescription: string = null,
    public isDisenroled: boolean = false,
  ) { super() }

  static clone(obj: any) {
    const t = new this()

    if (obj.cycleTransactionType) {
      t.cycleTransactionType = obj.cycleTransactionType }

    if (obj.originalAmountToRecover != undefined) {
      t.originalAmountToRecover = obj.originalAmountToRecover }

    if (obj.amountProcessedSince != undefined) {
      t.amountProcessedSince = obj.amountProcessedSince }

    if (obj.rootTransactionDescription) {
      t.rootTransactionDescription = obj.rootTransactionDescription }

    if (obj.isDisenroled) { t.isDisenroled = obj.isDisenroled }

    return t
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/transaction-cycle-metadata.ts